import ReportVisitor from "../../reports/reports/ReportVisitor.js";

const costsAccountGroupId = "Costs";

/**
 * This visitor is responsible for detecting if a row is a "Costs" row
 * or not. It is used by the forecast editor to flip the sign of all
 * "Costs" rows.
 */
export default class IsCostAccountRowVisitor extends ReportVisitor {
	visitAbstractRow(_row) {
		return false;
	}

	visitAccountGroupRow(row) {
		return row.getAccountGroup().isChildOf(costsAccountGroupId);
	}

	visitAccountRow(row) {
		return row.hasAccountPartOf(costsAccountGroupId);
	}

	visitGroupRow(row) {
		const firstChild = row.getRows()[0];

		if (!firstChild) return super.visitGroupRow(row);

		return this.visit(firstChild);
	}
}
